import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Menu,
  MenuItem,
  IconButton,
  Typography,
  Container,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  TextField,
  Card,
  FormControl,
  Box,
  InputLabel,
  Select,
  Checkbox,
  Button,
  InputAdornment,
  ListItemText,
  Input,
  Chip,
  Icon,
  FormHelperText,
  CircularProgress,
  Divider,
} from "@mui/material";
import Flag from "react-world-flags";
import axios from "axios";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { endpoints } from "../../../services/endpoint"; // Importing named export
import { axiosInstance } from "../../../services/axiosInstance"; // Importing named export
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import UploadFileModal from "./uploadmodal";
import AccountCircle from "@mui/icons-material/AccountCircle";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useNavigate, useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import "./addusers.css";
import { Login } from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const AddUserPage = ({onClose, onProfileAdded, onBulkProfileAdded}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedOption, setSelectedOption] = useState("option1");
  const navigate = useNavigate();

  const [phoneType, setPhoneType] = useState("");
  const [value, setValue] = useState(0);
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  const [login, setlogin] = useState([]);
  const [awsAccount, setAwsAccount] = useState("");
  const [ID, setID] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [confirmpassword, setConfirmpassword] = useState("");
  const [useremail, setEmail] = useState("");
  const [secondaryemail, setSecondaryemail] = useState("");
  const [phone, setPhone] = useState("");
  const [AgentRole, setAgentRole] = useState("");
  const [routingProfiles, setRoutingProfiles] = useState([]);
  const [RoutingProfile, setRoutingProfile] = useState("");
  const [deskphoneNumber, setdeskphoneNumber] = useState("");
  const [AutoAccept, setAutoAccept] = useState(false);
  const [acwtime, setAcwtime] = useState(0);
  const [key, setKey] = useState("");
  const [tagValue, setTagValue] = useState("");
  const [tags, setTags] = useState([]);
  const [loginNames, setLoginNames] = useState([]);
  const [actionClicked, setActionClicked] = useState(null); 
  const [saveLoader, setSaveLoader] = useState(false);
  const [cancelButtonLoading, setCancelButtonLoading] = useState(false);
  // const getLoginsFromLocalStorage = () => {
  //   const storedLogins = localStorage.getItem('logins');
  //   if (storedLogins) {
  //     const loginsArray = JSON.parse(storedLogins);
  //     console.log("Retrieved Logins from localStorage:", loginsArray);
  //     return loginsArray;
  //   } else {
  //     console.log("No logins found in localStorage.");
  //     return [];
  //   }
  // };
  const [showTags, setShowTags] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
 
  const accountNo = localStorage.getItem("selectedAccountNo");
 
  const id = localStorage.getItem("selectedID");
  const accessurl = localStorage.getItem("selctedurl");
  const handleClickShowRepeatPassword = () => {
    setShowRepeatPassword(!showRepeatPassword);
  };
  const handleKeyChange = (event) => {
    setKey(event.target.value);
  };
  const instanceAlias = localStorage.getItem("instanceName");
  const instanceId = localStorage.getItem("InstanceId");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const region = localStorage.getItem("Region");
  
  const username = localStorage.getItem("username");
    const EncryptedInstanceId=localStorage.getItem("EncryptedId");
      const email = localStorage.getItem("Email");
  const [error, setError] = useState({});
  const location = useLocation();
  const [openModal, setOpenModal] = useState(false);
  const [selectedProfiles, setSelectedProfiles] = useState([]);
  const [existingLogins, setExistingLogins] = useState([]);
  useEffect(() => {
    if (location.state?.existingLogins) {
      setExistingLogins(location.state.existingLogins);
      console.log("Loaded existing logins:", location.state.existingLogins);
    }
  }, [location]);

  const validateLogin = (value) => {
    const trimmedValue = value.trim();

    // Check if the login matches any existing login (case insensitive)
    const loginExists = existingLogins.some(
      (existingLogin) =>
        existingLogin.toLowerCase() === trimmedValue.toLowerCase()
    );

    if (loginExists) {
      setError((prev) => ({
        ...prev,
        login: "A user with this login already exists",
      }));
      return false;
    }

    if (!trimmedValue) {
      setError((prev) => ({
        ...prev,
        login: "Login is required",
      }));
      return false;
    }

    if (trimmedValue.length > 50) {
      setError((prev) => ({
        ...prev,
        login: "Login must be 50 characters or less",
      }));
      return false;
    }

    // If the value contains '@', validate as an email
    if (trimmedValue.includes("@")) {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!emailPattern.test(trimmedValue)) {
        setError((prev) => ({
          ...prev,
          login: "Please enter a valid email address",
        }));
        return false;
      }
    }

  
    setError((prev) => ({
      ...prev,
      login: null,
    }));
    return true;
  };



  const handleSelectChange = (event) => {
    setSelectedProfiles(event.target.value);
  };
  const handleValueChange = (event) => {
    setTagValue(event.target.value);
  };
  const handleToggle = (value) => {
    setSelectedProfiles((prev) => {
      const newSelectedProfiles = prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value];

      setError((prevErrors) => ({
        ...prevErrors,
        selectedProfiles:
          newSelectedProfiles.length > 0 ? null : prevErrors.selectedProfiles,
      }));

      return newSelectedProfiles;
    });
  };

  const handleAddTag = () => {
    if (key && tagValue) {
      setTags((prevTags) => [
        ...prevTags,
        { key, value: tagValue }, // Add new tag as an object with key-value
      ]);
      setKey("");
      setTagValue("");
    }
  };

  const handleDeleteTag = (tagKeyToDelete) => {
    setTags((prevTags) => {
      const updatedTags = { ...prevTags };
      delete updatedTags[tagKeyToDelete]; // Remove the tag by its key
      return updatedTags;
    });
  };

  const toggleShowTags = () => setShowTags(!showTags);
  const handleAcwtimeChange = (value) => {
    const intValue = parseInt(value, 10); // Convert the value to an integer
    setAcwtime(intValue);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handlePhoneChange = (e) => {
    setPhone(e.target.value); // Set phone number
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleContactControlPanelClick = () => {
    navigate("/connect-ccp");
  };

  const handleIncrement = () => {
    setValue((prev) => prev + 1);
  };

  // Function to decrement the value
  const handleDecrement = () => {
    setValue((prev) => (prev > 0 ? prev - 1 : 0));
  };
  const validateFields = () => {
    const newErrors = {};

    if (!firstname) {
      newErrors.firstname = "First name is required";
    } else if (/[^a-zA-Z\s]/.test(firstname)) {
      newErrors.lastname = "Last name should not contain special characters";
    }
    if (!lastname) {
      newErrors.lastname = "Last name is required";
    } else if (/[^a-zA-Z\s]/.test(lastname)) {
      newErrors.firstname = "First name should not contain special characters";
    }

    if (!login) newErrors.login = "Login is required";
    if (!email) newErrors.email = "Email address is required";
    // if(!secondaryemail) newErrors.secondaryemail ="Secondary email is required";
    if (!validateEmail(email)) newErrors.email = "Invalid email address";
    if (secondaryemail && !validateEmail(secondaryemail)) {
      newErrors.secondaryemail = "Invalid secondary email";
    }

    if (!password) newErrors.password = "Password is required";
    if (!repeatPassword)
      newErrors.repeatPassword = "Repeat password is required";
    if (password !== repeatPassword)
      newErrors.repeatPassword = "Passwords do not match";

    if (selectedProfiles.length === 0) {
      newErrors.selectedProfiles =
        "At least one security profile must be selected";
    }

    // Ensure routing profile is selected
    if (!RoutingProfile) {
      newErrors.RoutingProfile = "Routing profile is required";
    }
    if (!phoneType) {
      newErrors.phoneType = "Phone type is required";
    }

    // Validate additional fields based on phone type
    if (phoneType === "DESK_PHONE") {
      if (!countryCode) {
        newErrors.countryCode = "Country code is required";
      }
      if (!deskphoneNumber) {
        newErrors.deskphoneNumber = "Desk phone number is required";
      }
    }

    if (phoneType === "SOFT_PHONE" && AutoAccept) {
      newErrors.AutoAccept = "You must select auto-accept for Soft Phone";
    }
    // Add validations for other fields...

    setError(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };
  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;

    // Ensure the value is a positive integer
    if (inputValue === "" || /^[0-9\b]+$/.test(inputValue)) {
      setValue(Number(inputValue));

      setError((prevErrors) => ({
        ...prevErrors,
        selectedProfiles: null,
      }));
    }
  };

  const handlePhoneTypeChange = (event) => {
    setPhoneType(event.target.value);
  };

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfile = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
  
  };
  const [showProfileDetails, setShowProfileDetails] = useState(false);
 
  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
    setShowProfileDetails(true);
  };
  const handleMyProfileClick = () => {
    setShowProfileDetails(true);
  };
  const handleClose = () => {
    setShowProfileDetails(false);
    setAnchorEl(null);
  };
   const handleCancel = () => {
     setActionClicked("cancel");
    setCancelButtonLoading(true);
    setTimeout(() => {
      setCancelButtonLoading(false);
        setActionClicked(null);
      onClose(); // ✅ now calls onClose instead of undefined onCancel
    }, 500);
  };
  const handleCountryCodeChange = (e) => {
    setCountryCode(e.target.value); // Set selected country code
  };

  const fetchRoutingProfiles = async () => {
    try {
      const payload = {
        InstanceAlias:instanceAlias,
        awsAccount:customerAWSAccountId,
        region,
       ID:EncryptedInstanceId,
      };

      const response = await axiosInstance.post(
        endpoints.addRouting.listrouting,
        payload,
        {
          headers: {
            "Content-Type": "application/json", // Ensure content type is set correctly
          },
        }
      );

      console.log("Fetched Routing Profiles:", response.data);
      setRoutingProfiles(response.data); // Set the state with fetched profiles
    } catch (error) {
      if (error.response) {
        console.error("Error response data:", error.response.data);
        console.error("Error status:", error.response.status);

        // You can show a user-friendly message based on status code
        if (error.response.status === 403) {
          alert("You do not have permission to access this resource.");
        }
      } else {
        console.error("Error message:", error.message);
      }
    }
  };

    const handleLoginChange = (e) => {
    const newLogin = e.target.value;
    setlogin(newLogin);
    validateLogin(newLogin); // Validate as the user types
  };

  
  useEffect(() => {
    fetchRoutingProfiles();
  }, []);
//   const fetchUsers = async () => {
//   const payload = {
//     ID:EncryptedInstanceId,
//     awsAccount: customerAWSAccountId,
//     region: region,
//     InstanceAlias: instanceAlias,
//     UserName: username,
//     Email:email,
//   };

//   try {
//     const response = await axiosInstance.post(
//       endpoints.userList.listusers,
//       payload
//     );

//     console.log("Response Data:", response.data);

//     if (response.data && Array.isArray(response.data)) {
//       const extractedData = response.data.map((item) => ({
//         Login: item.Login,
//         FullName: item.FullName,
//         RoutingProfile: item.RoutingProfile,
//         ACWTimeout: item.ACWTimeout,
//         FirstName: item.FirstName,
//         LastName: item.LastName,
//         Email: item.Email,
//         SecondaryEmail: item.SecondaryEmail,
//         ARN: item.ARN,
//         AutoAccept: item.AutoAccept,
//         DeskPhone: item.DeskPhone,
//         PhoneType: item.PhoneType,
//         SecurityProfiles: item.SecurityProfiles,
//         Tags: item.Tags,
//       }));

//       console.log("Extracted User Data:", extractedData);
//       return extractedData; // ✅ Return here
//     } else {
//       console.warn("Unexpected response structure:", response.data);
//       return [];
//     }
//   } catch (error) {
//     console.error("Error fetching users:", error);
//     return [];
//   }
// };
const fetchUsers = async () => {
  const payload = {
    ID: EncryptedInstanceId,
    awsAccount: customerAWSAccountId,
    region: region,
    InstanceAlias: instanceAlias,
    UserName: username,
    Email: email,
  };

  try {
    const response = await axiosInstance.post(
      endpoints.userList.listusers,
      payload
    );

    console.log("Full API Response:", response.data);

    // ✅ Extract body correctly
    const users = response.data?.body;

    if (Array.isArray(users)) {
      const extractedData = users.map((item) => ({
        Login: item.Login,
        FullName: item.FullName,
        RoutingProfile: item.RoutingProfile,
        ACWTimeout: item.ACWTimeout,
        FirstName: item.FirstName,
        LastName: item.LastName,
        Email: item.Email,
        SecondaryEmail: item.SecondaryEmail || "",
        ARN: item.ARN,
        AutoAccept: item.AutoAccept,
        DeskPhone: item.DeskPhone || "",
        PhoneType: item.PhoneType,
        SecurityProfiles: item.SecurityProfiles || [],
        Tags: item.Tags || {},
      }));

      console.log("Extracted User Data:", extractedData);
      return extractedData;
    } else {
      console.warn("Users list is not an array:", users);
      return [];
    }
  } catch (error) {
    console.error("Error fetching users:", error);
    return [];
  }
};

const savedUsername = localStorage.getItem("username");
 const handleSave = async () => {
  if (!validateFields()) return;
setActionClicked("save");
  setSaveLoader(true);

  const requestPayload = {
    action: "create",
    username: login,
    accessurl: "https://sravani-connectgen.my.connect.aws",
    ID:EncryptedInstanceId,
    awsAccount:customerAWSAccountId, // used your second awsAccount value as source of truth
    InstanceAlias: instanceAlias,
    region,
    Email: email,         // hardcoded email
    UserName:username,                        // hardcoded UserName
    firstname,
    lastname,
    password,
    confirmpassword: repeatPassword,
    SecondaryEmail: secondaryemail,
    email:useremail,                                       // from form field
    AgentRole: selectedProfiles,
    RoutingProfile,
    AutoAccept,
    Acwtime: value,
    phone_type: phoneType,
    Tags: tags.length > 0 ? tags : undefined,
  };

  if (phoneType === "DESK_PHONE") {
    requestPayload.DeskPhoneNumber = countryCode + deskphoneNumber;
  }

  try {
    const response = await axiosInstance.post(
      endpoints.addUser.newuser,
      requestPayload
    );

    console.log("User added successfully:", response.data);

    if (response.status === 200) {
      const updatedList = await fetchUsers(); // refresh user list
    
        onProfileAdded(updatedList);
   
      onClose();
    }
  } catch (error) {
    console.error("Error adding user:", error);
  } finally {
    setSaveLoader(false);
    setActionClicked(null);
  }

  if (tags.length === 0) {
    console.log("No tags to submit.");
  }
};


  const handleDownloadTemplateClick = async () => {
    try {
      // Make the API request to get the CSV file
      const response = await axiosInstance.get(endpoints.downloadurl.download, {
        responseType: "blob", // Ensure we get the response as a blob
      });

      if (response.status === 200) {
        // Create a Blob from the response data
        const blob = new Blob([response.data], {
          type: response.headers["content-type"], // Get the content type from headers
        });

        // Create a URL for the Blob
        const url = URL.createObjectURL(blob);

        // Create a link element to trigger the download
        const link = document.createElement("a");
        link.href = url;
        link.download = "Agentstemplate.csv";

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(url); // Free up memory
      } else {
        console.error("Failed to download template:", response.statusText);
        alert("Failed to download the template. Please try again.");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      alert("An error occurred while downloading the file.");
    }
  };

  const validatePassword = (pass) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(pass);
  };

  const handleBackClick = async () => {
    const payload = {
      instanceAlias,
      awsAccount: accountNo,
      region,
      ID: id,
    };

    try {
      const response = await axiosInstance.post(
        endpoints.userList.listusers,
        payload
      );
      console.log("Response Data:", response.data);

      if (response.data && Array.isArray(response.data)) {
        const extractedData = response.data.map((item) => ({
          Login: item.Login,
          FullName: item.FullName,
          RoutingProfile: item.RoutingProfile,
          ACWTimeout: item.ACWTimeout,
          FirstName: item.FirstName,
          LastName: item.LastName,
          Email: item.Email,
          SecondaryEmail: item.SecondaryEmail,
          ARN: item.ARN,
          AutoAccept: item.AutoAccept,
          DeskPhone: item.DeskPhone,
          PhoneType: item.PhoneType,
          SecurityProfiles: item.SecurityProfiles,
          Tags: item.Tags,
        }));

        console.log("Fetched Users:", extractedData);
        navigate("/userConfigure-page", { state: { extractedData } });
        return extractedData;
      } else {
        console.error("Unexpected response format:", response.data);
        return null;
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response data:", error.response.data);
      } else {
        console.error("Error message:", error.message);
      }
      return null;
    }
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);

    if (!validatePassword(value)) {
      setError((prev) => ({
        ...prev,
        password:
          "Password must contain at least 8 characters, including uppercase, lowercase letters, numbers, and special characters.",
      }));
    } else {
      setError((prev) => ({ ...prev, password: null }));
    }
  };

  const handleRepeatPasswordChange = (e) => {
    const value = e.target.value;
    setRepeatPassword(value);

    if (value !== password) {
      setError((prev) => ({
        ...prev,
        repeatPassword: "Passwords do not match.",
      }));
    } else {
      setError((prev) => ({ ...prev, repeatPassword: null }));
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      // Perform any action you want when the Enter key is pressed
      console.log("Enter key pressed");
    } else if (e.key === "ArrowUp") {
      // Handle increment when the up arrow key is pressed
      handleIncrement();
    } else if (e.key === "ArrowDown") {
      // Handle decrement when the down arrow key is pressed
      handleDecrement();
    }
  };
  return (
  
     
      
      <Container className="addusers-content-container">
         <Box display="flex" flexDirection="column" alignItems="flex-start" mb={2} gap={1}>
  {/* Back Arrow in a circular button */}
  <IconButton
    onClick={onClose}
    size="medium"
    sx={{
      border: "1px solid #ccc",       // border color
      borderRadius: "50%",            // makes it circular
      padding: 1,                     // inner spacing
      bgcolor: "#f5f5f5",             // background color
      "&:hover": { bgcolor: "#e0e0e0" } // hover effect
    }}
  >
    <ArrowBackIcon />
  </IconButton>

  {/* Title */}
  <Typography variant="h4" className="phone-text">
    Add User
  </Typography>
</Box>

        <Typography variant="h5" gutterBottom>
          Add users and configure them with permissions that are appropriate to
          their roles.
        </Typography>
        <br />
        <div className="user-info-container">
          <FormControl component="fieldset" className="custom-radio-group">
            <RadioGroup
              aria-label="user-options"
              name="user-options"
              value={selectedOption}
              onChange={handleOptionChange}
            >
              <FormControlLabel
                value="option1"
                control={<Radio />}
                label="Add a user manually"
              />
              <FormControlLabel
                value="option2"
                control={<Radio />}
                label="Import users using a .csv template"
              />
            </RadioGroup>
          </FormControl>
          <br />
          <br />
          {selectedOption === "option1" && (
            <div>
              {/* First Section */}
              <div className="addusers-user-form-section">
                <h3>User Information</h3>
                <div className="addusers-user-form-fields">
                  <TextField
                    label="First name"
                    
                    placeholder="Enter name"
                    required
                    value={firstname}
                    onChange={(e) => {
                      const value = e.target.value;

                      // Check if the input contains only letters and spaces
                      if (/^[a-zA-Z\s]*$/.test(value)) {
                        setFirstname(value); // Update if valid
                        setError((prevError) => ({
                          ...prevError,
                          firstname: null, // Clear error when valid
                        }));
                      } else {
                        setFirstname(value); // Still update value to let user fix it
                        setError((prevError) => ({
                          ...prevError,
                          firstname:
                            "First name should not contain special characters,numbers",
                        })); // Set error if invalid
                      }
                    }}
                    helperText={error.firstname}
                    error={!!error.firstname}
                    className="adduser-userinfo-formfield"
                  />

                  <TextField
                    label="Last name"
                   
                    placeholder="Enter last name"
                    required
                    value={lastname}
                    onChange={(e) => {
                      const value = e.target.value;

                      // Check if the input contains only letters and spaces
                      if (/^[a-zA-Z\s]*$/.test(value)) {
                        setLastname(value); // Update if valid
                        setError((prevError) => ({
                          ...prevError,
                          lastname: null, // Clear error when valid
                        }));
                      } else {
                        setLastname(value); // Update value so user can see their input
                        setError((prevError) => ({
                          ...prevError,
                          lastname:
                            "Last name should not contain special characters, numbers",
                        })); // Set error if invalid
                      }
                    }}
                    helperText={error.lastname}
                    error={!!error.lastname}
                    className="adduser-userinfo-formfield"
                  />

                  <TextField
                    label="Login"
                   
                    value={login}
                    placeholder="Enter login"
                    onChange={handleLoginChange}
                    helperText={error.login}
                    error={!!error.login}
                    className="span-two-columns"
                  />

                  <TextField
                    label="Email address"
                    placeholder="Enter Email"
                    required
                    value={useremail}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setError({ ...error, email: null });
                    }}
                    helperText={error.email}
                    error={!!error.email}
                    className="adduser-userinfo-formfield"
                  />
                  <TextField
                    label="Secondary email address"
                   placeholder="Enter Email"
                    value={secondaryemail}
                    onChange={(e) => {
                      setSecondaryemail(e.target.value);
                      setError((prev) => ({ ...prev, secondaryemail: null })); // Clear error on change
                    }}
                    helperText={error.secondaryemail}
                    error={!!error.secondaryemail}
                    className="adduser-userinfo-formfield"
                  />

                  <TextField
                    label="Password"
                    placeholder="Enter Password"
                    required
                    type={showPassword ? "text" : "password"}
                    value={password}
                    helperText={error.password}
                    error={!!error.password}
                    onChange={handlePasswordChange}
                    onCopy={(e) => e.preventDefault()} // Prevent copying
                    onPaste={(e) => e.preventDefault()} // Prevent pasting
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            edge="end"
                            size="small"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    className="adduser-userinfo-formfield"
                  />
                  <TextField
                    label="Confirm password"
                   placeholder="Enter Confirm Password"
                    required
                    type={showRepeatPassword ? "text" : "password"}
                    value={repeatPassword}
                    onChange={handleRepeatPasswordChange}
                    onCopy={(e) => e.preventDefault()} // Prevent copying
                    onPaste={(e) => e.preventDefault()} // Prevent pasting
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle repeat password visibility"
                            onClick={handleClickShowRepeatPassword}
                            edge="end"
                       
                          >
                            {showRepeatPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    helperText={error.repeatPassword}
                    error={!!error.repeatPassword}
                    className="adduser-userinfo-formfield"
                  />
                </div>
              </div>

              {/* Second Section */}
            <div className="addusers-setting-form-section">
  <h3>Settings</h3>
  <div className="addusers-setting-form-fields">

    <TextField
  select
  required
  label={
    <>
      Security profile <span className="startmarksecurity"></span>
    </>
  }
  value={selectedProfiles}
  error={!!error.selectedProfiles}
  helperText={error.selectedProfiles}
  className="adduser-securityprofile"
  SelectProps={{
    multiple: true,
    renderValue: (selected) => selected.join(", "),
  }}
>
  {["Admin", "Agent", "CallCenterManager", "QualityAnalyst"].map(
    (profile) => (
      <MenuItem
        key={profile}
        value={profile}
        onClick={() => {
          // toggle logic
          const currentIndex = selectedProfiles.indexOf(profile);
          const newSelected = [...selectedProfiles];

          if (currentIndex === -1) {
            newSelected.push(profile);
          } else {
            newSelected.splice(currentIndex, 1);
          }

          setSelectedProfiles(newSelected); // update state
          setError({ ...error, selectedProfiles: null }); // clear error
        }}
      >
        <Checkbox checked={selectedProfiles.includes(profile)} />
        {profile.replace(/([A-Z])/g, " $1").trim()}
      </MenuItem>
    )
  )}
</TextField>


    {/* Routing Profile */}
    <TextField
      select
      required
      label="Routing Profile"
      value={RoutingProfile}
      onChange={(e) => {
        setRoutingProfile(e.target.value);
        setError({ ...error, RoutingProfile: null });
      }}
      helperText={error.RoutingProfile}
      error={!!error.RoutingProfile}
      className="adduser-routingprofile"
    >
      {routingProfiles.map((profile, index) => (
        <MenuItem key={index} value={profile}>
          {profile}
        </MenuItem>
      ))}
    </TextField>


    <Typography className="adduserinfo-phonetext">Phone</Typography>

    <div className="phone-type-options">
      {/* Phone Type */}
      <TextField
        select
        required
        label={
          <>
            Phone Type <span className="startmarksecurity"></span>
          </>
        }
        value={phoneType}
        onChange={(e) => {
          setPhoneType(e.target.value);
          setError({ ...error, phoneType: null });
        }}
        helperText={error.phoneType}
        error={!!error.phoneType}
        className="phonetypetextfield"
      >
        <MenuItem value="SOFT_PHONE">SOFT_PHONE</MenuItem>
        <MenuItem value="DESK_PHONE">DESK_PHONE</MenuItem>
      </TextField>

      {/* Auto-Accept for Soft Phone */}
      {phoneType === "SOFT_PHONE" && (
        <FormControlLabel
          control={<Checkbox size="small" checked={AutoAccept} />}
          label="Auto-accept calls"
          className="auto-accept-checkbox"
          value={AutoAccept}
          onChange={(e) => {
            setAutoAccept(e.target.checked);
            setError({ ...error, AutoAccept: null });
          }}
        />
      )}

      {/* Desk Phone Options */}
      {phoneType === "DESK_PHONE" && (
        <div className="desk-phone-options">
        
          <TextField
            select
            label="Country Code"
            value={countryCode}
            
            onChange={(e) => {
              setCountryCode(e.target.value);
              setError({ ...error, countryCode: null });
            }}
            helperText={error.countryCode}
            error={!!error.countryCode}
              sx={{ minWidth: 300 }}
            
          >
            <MenuItem value="+1">
              <Flag code="US" className="edituser-flagstyling" />
              +1 (United States)
            </MenuItem>
            <MenuItem value="+1-CA">
              <Flag code="CA" className="edituser-flagstyling" />
              +1 (Canada)
            </MenuItem>
            <MenuItem value="+44">
              <Flag code="GB" className="edituser-flagstyling" />
              +44 (United Kingdom)
            </MenuItem>
            <MenuItem value="+52">
              <Flag code="MX" className="edituser-flagstyling" />
              +52 (Mexico)
            </MenuItem>
            <MenuItem value="+1-PR">
              <Flag code="PR" className="edituser-flagstyling" />
              +1 (Puerto Rico)
            </MenuItem>
          </TextField>

          {/* Desk Phone Number */}
          <TextField
            label="Desk Phone Number"
            value={deskphoneNumber}
            onChange={(e) => {
              setdeskphoneNumber(e.target.value);
              setError({ ...error, deskPhoneNumber: null });
            }}
          
            error={!!error.deskphoneNumber}
            helperText={error.deskphoneNumber}
              sx={{ minWidth: 300 }}
          />
          
        </div>
      )}
      
    </div>


      <Typography
                    style={{
                      fontWeight: "bold",
                      gridColumn: "span 2",
                      fontSize: "14px",
                    }}
                  >
                    After Contact Work (ACW) timeout
                  </Typography>
                  <TextField
                   
                    type="text"
                    placeholder="Timeout (seconds)"
                    value={value}
                    helperText={error.value} // Display error here
                    error={!!error.value}
                    onChange={(e) => setValue(Number(e.target.value))}
                    onKeyDown={(e) => handleKeyDown(e)}
                    InputProps={{
                      className: "inputElement",
                      endAdornment: (
                        <InputAdornment position="end">
                          <div className="buttonGroup">
                            <IconButton
                              className="incrementButton"
                              onClick={handleIncrement}
                              size="medium"
                              //style={{color:'#1a73e8'}}
                            >
                              ▴
                            </IconButton>
                            <IconButton
                              className="decrementButton"
                              onClick={handleDecrement}
                              size="medium"
                              //style={{color:'#1a73e8'}}
                            >
                              ▾
                            </IconButton>
                          </div>
                        </InputAdornment>
                      ),
                    }}
                    className="inputRoot"
                  />
                </div>
                <Box className="adduser-tags-container">
                  {/* Toggle button to show/hide the entire tags functionality */}
                  <Box
                    className="addusertagsdisplaybox"
                    onClick={toggleShowTags}
                  >
                    <Typography className="adduser-showtext-tags">
                      Show advanced settings
                    </Typography>
                    <IconButton className="adduser-arrow-buttons-styling">
                      {showTags ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                    </IconButton>
                  </Box>


                  {showTags && (
                    <Box>
                      <Typography className="addusertagsheading">
                        Tags (Optional)
                      </Typography>
                      <Typography className="adduser-belowtextstyle-tags">
                        You can add resource tags to identify, organize, search
                        for, filter, and control who can access this prompt.
                        <a
                          href="https://docs.aws.amazon.com/connect/latest/adminguide/tagging.html"
                          target="_blank"
                          className="adduser-learnmore"
                        >
                          Learn More.
                        </a>
                      </Typography>

                      <Box
                                                         display="flex"
                                                         gap={1}
                                                         mt={2}
                                                       >
                        <TextField
                          label="Key"
                          
                          value={key}
                          onChange={handleKeyChange}
                          className="adduser-keytag-field"
                        />
                        <TextField
                          label="Value"
                         
                          value={tagValue}
                          onChange={handleValueChange}
                          className="adduser-input-field"
                          disabled={!key}
                        />
                        <Button
                          variant="outlined"
                          className="adduser-add-button"
                          onClick={handleAddTag}
                          disabled={!key || !tagValue}
                        >
                          Add
                        </Button>
                      </Box>

                      {Object.keys(tags).length > 0 && (
                        <Box className="adduser-tags-display">
                          <Typography
                            variant="subtitle1"
                            className="adduser-selecttext"
                          >
                            Selected tags
                          </Typography>
                          <Typography
                            variant="body2"
                            className="adduser-belowtagtext"
                          >
                            You can add up to {50 - Object.keys(tags).length}{" "}
                            more tags
                          </Typography>
                          <Box className="adduser-tags-list">
                            {tags.map((tag, index) => (
                              <Chip
                                key={index}
                                size="small"
                                label={
                                  <span>
                                    <b>{tag.key}</b>: {tag.value}
                                  </span>
                                }
                                onDelete={() => handleDeleteTag(index)} // Delete based on index
                                className="adduser-tag-chip"
                              />
                            ))}
                          </Box>
                        </Box>
                      )}
                    </Box>
                  )}
                </Box>
              </div>
             
<div className="buttons-addhour">
                <Button
                  onClick={handleCancel}
                  // className="adduser-cancel-button"
                  disabled={actionClicked === "save" || cancelButtonLoading}
      >
        <span className="adduser-button-content">
          {actionClicked === "cancel" ? (
            <CircularProgress  size={18} style={{ color: "red" }} />
          ) : (
            "Cancel"
          )}
                  </span>
                </Button>
                <Button
                  onClick={handleSave}
                 variant="contained"
              disabled={actionClicked === "cancel" || saveLoader}
      >
        <span className="adduser-button-content">
          {actionClicked === "save" ? (
            <CircularProgress size={18} style={{ color: "white" }} />
          ) : (
            "Save"
          )}
                  </span>
                </Button>
              </div>
              <br />
            </div>
          )}
          {selectedOption === "option2" && (
            <div className="option2-container">
              <h2>Follow these steps:</h2> <br />
              <div className="steps">
                <div className="step">
                  <span className="step-number">1</span>
                  <span className="firststeptext">
                    Download template.{" "}
                    <span
                      className="ref-link"
                      onClick={handleDownloadTemplateClick}
                      style={{ cursor: "pointer", color: "#0D4CCD" }} // Optional styles for better UX
                    >
                      (Agents template.csv)
                    </span>
                  </span>
                </div>
                <div className="step">
                  <span className="step-number">2</span>
                  <span className="firststeptext">
                    Add data to the template (
                    <a href="#" className="ref-link">
                      Learn more
                    </a>
                    )
                  </span>
                </div>
                <div className="step">
                  <span className="step-number">3</span>
                  <span className="firststeptext">
                    Save the .csv file and upload.
                  </span>
                </div>
              </div>
              <button className="upload-button" onClick={handleOpenModal}>
                Upload file
              </button>
              {openModal && <UploadFileModal closeModal={handleCloseModal} onProfileAdded={onBulkProfileAdded} onClose={handleCloseModal} />}
            </div>
          )}
        </div>
      </Container>
 
  );
};

export default AddUserPage;
